module.exports = __webpack_public_path__ + "img/product_summary.46a6b5c8.png";